import { makeStyles } from '@material-ui/core/styles';

export const useSelectStyles = makeStyles((theme) => ({
  select: {
    borderRadius: 4,
    '&:focus': {
      borderRadius: 4,
    },
  },
  filled: {
    paddingRight: theme.spacing(4),
  },
}));
